module.exports = __webpack_public_path__ + "static/media/lettering-board1.aa11ddee.jpg";